import React from 'react';

import type { City } from '../../src/enums/city';
import type { CmsClubDetails } from '../../src/helpers/club-finder-helper';

export type ClubFinderConfig = {
  location: google.maps.LatLngLiteral | null;
  setLocation: (newLocation: google.maps.LatLngLiteral) => void;

  geolocation: boolean;
  setGeolocation: (newGeolocation: boolean) => void;

  map: google.maps.Map | null;
  setMap: (newMap: google.maps.Map | null) => void;

  highlightedClubId: number | null;
  setHighlightedClubId: (newHighlightedClubId: number | null) => void;
  zoomedClubId: number | null;
  setZoomedClubId: (newZoomedClubId: number | null) => void;
  isLocationError: boolean;
  setIsLocationError: (value: boolean) => void;
  nearestPlace: { name: string | undefined } | null;
  setNearestPlace: (value: { name: string | undefined } | null) => void;
  selectedClubId: number | null;
  setSelectedClubId: (clubId: number | null) => void;

  showMarkers: boolean;
  setShowMarkers: (newShowMarkers: boolean) => void;

  clubs: CmsClubDetails[];

  city?: City;
};

export const ClubFinderContext = React.createContext<ClubFinderConfig>(undefined as never);
